import { render, staticRenderFns, recyclableRender, components } from "./uni-search-bar.vue?vue&type=template&id=64ee3838&scoped=true&"
var renderjs
import script from "./uni-search-bar.vue?vue&type=script&lang=js&"
export * from "./uni-search-bar.vue?vue&type=script&lang=js&"
import style0 from "./uni-search-bar.vue?vue&type=style&index=0&id=64ee3838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee3838",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uni-search-bar/uni-search-bar.vue"
export default component.exports